import * as React from 'react';
import * as styles from './MyLink.css';
import { IAIcon } from '../../icon/Icon';
import { MyLinksStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { Helper } from '../../../Helper';

export interface IProps {
  myLinksStore?: MyLinksStore;
  index?: number;
  icon?: string;
  title: string;
  url: string;
  description?: string;
  showSkeleton?: boolean;
  styles?: React.CSSProperties;
  onChange: () => void;
}

@inject('myLinksStore')
@observer
export class MyLink extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  public render(): JSX.Element {
    let link: JSX.Element;
    let displayType = this.props.myLinksStore.displayType;
    if (this.props.myLinksStore.editMode) {
      displayType = "Standard";
    }
    switch (displayType) {
      case "Standard":
        link = (
          <div
            className={this.props.myLinksStore.editMode || this.props.myLinksStore.displayType === "Standard" ? styles.IA_linkButton : styles.IA_linkButtonCondensed}
            draggable={!this.props.myLinksStore.isSaving}
            onDragStart={() => {
              this.props.myLinksStore.isDraggingItemWithIndex = this.props.index;
              this.props.myLinksStore.addDroppableItemAtIndex(this.props.index);
            }}
            onDragEnd={() => {
              this.props.myLinksStore.isSaving = true;
              setTimeout(() => {
                this.props.myLinksStore.isSaving = false;
                this.props.onChange();
              }, 500);
            }}
            onDragEnter={() => {
              this.props.myLinksStore.isDraggingOverItemWithIndex(this.props.index);
            }}
            style={{
              opacity: this.props.myLinksStore.isSaving ? 0.5 : 1,
              backgroundColor: this.props.myLinksStore.linkBackgroundColor,
              borderRadius: this.props.myLinksStore.linkBorderRadius,
              boxShadow: this.props.myLinksStore.linkDropShadow ? "rgba(0, 0, 0, 0.2) 0 0 5px 0" : "none",
              borderColor: this.props.myLinksStore.linkBorderColor ?? "transparent",
              borderStyle: this.props.myLinksStore.editMode ? "solid" : this.props.myLinksStore.linkBorderStyle ?? "solid",
              ...this.props.styles
            }}
          >
            <div
              className={styles.IA_icon}
            >
              <IAIcon
                title={this.props.icon ?? this.props.myLinksStore.defaultLinkIcon}
                size={26}
                color={this.props.myLinksStore.linkIconColor ?? this.props.myLinksStore.highlightColor}
              />
            </div>
            <a href={this.props.url} target="_blank">
              <div
                className={styles.IA_title}
                style={{
                  color: this.props.myLinksStore.linkTextColor ?? "#333333",
                  width: this.props.myLinksStore.editMode ? "calc(100% - 130px)" : "calc(100% - 60px)"
                }}
              >
                {this.props.title}
              </div>
            </a>
            {this.props.myLinksStore.editMode &&
              <div
                className={styles.IA_icon}
                style={{
                  float: "right",
                  paddingTop: 12
                }}
              >
                <IAIcon
                  title={"Move"}
                  size={18}
                  color={this.props.myLinksStore.hasDarkBackground && ( this.props.myLinksStore.linkBackgroundColor == undefined || !Helper.isLightColor( this.props.myLinksStore.linkBackgroundColor)) ? "#ffffff" : this.props.myLinksStore.linkIconColor ?? this.props.myLinksStore.highlightColor}
                />
              </div>
            }
            {this.props.myLinksStore.editMode &&
              <div
                className={styles.IA_icon}
                style={{
                  float: "right",
                  marginRight: 0,
                  paddingTop: 12
                }}
                onClick={() => {
                  this.props.myLinksStore.itemToEditIndex = this.props.index;
                  this.props.myLinksStore.itemToEdit = this.props.myLinksStore.myLinks[this.props.index];
                  this.props.myLinksStore.itemToEditOriginal = Object.assign({}, this.props.myLinksStore.myLinks[this.props.index]);
                }}
              >
                <IAIcon
                  title={"Edit"}
                  size={18}
                  color={this.props.myLinksStore.hasDarkBackground && ( this.props.myLinksStore.linkBackgroundColor == undefined || !Helper.isLightColor( this.props.myLinksStore.linkBackgroundColor)) ? "#ffffff" : this.props.myLinksStore.linkIconColor ?? this.props.myLinksStore.highlightColor}
                />
              </div>
            }
          </div>
        );
        break;
      case "Condensed":
        link = (
          <div
            className={styles.IA_linkButtonCondensed}
            style={{
              opacity: this.props.myLinksStore.isSaving ? 0.5 : 1,
              borderRadius: this.props.myLinksStore.linkBorderRadius,
              ...this.props.styles
            }}
          >
            {this.props.icon ?
              <div
                className={styles.IA_iconCondensed}
              >
                <IAIcon
                  title={this.props.icon}
                  size={26}
                  color={this.props.myLinksStore.hasDarkBackground ? "#ffffff" : this.props.myLinksStore.linkIconColor ?? this.props.myLinksStore.highlightColor}
                />
              </div>
              :
              <div
                className={styles.IA_iconCondensed}
              >
                <IAIcon
                  title={this.props.myLinksStore.defaultLinkIcon}
                  size={26}
                  color={this.props.myLinksStore.hasDarkBackground ? "#ffffff" : this.props.myLinksStore.linkIconColor ?? this.props.myLinksStore.highlightColor}
                />
              </div>
            }
            <a href={this.props.url} target="_blank">
              <div
                className={styles.IA_titleCondensed}
                style={{
                  lineHeight: "25px",
                  color: this.props.myLinksStore.hasDarkBackground ? "#ffffff" : this.props.myLinksStore.linkTextColor ?? "#333333"
                }}
              >
                {this.props.title}
              </div>
            </a>
          </div>
        );
        break;
      case "Tiles":
        link = (
          <a href={this.props.url} target="_blank">
            <div
              className={styles.IA_linkButtonTile}
              style={{
                opacity: this.props.myLinksStore.isSaving ? 0.5 : 1,
                backgroundColor: this.props.myLinksStore.linkBackgroundColor,
                borderRadius: this.props.myLinksStore.linkBorderRadius,
                boxShadow: this.props.myLinksStore.linkDropShadow ? "rgba(0, 0, 0, 0.2) 0 0 5px 0" : "none",
                borderColor: this.props.myLinksStore.linkBorderColor,
                borderStyle: this.props.myLinksStore.linkBorderStyle,
                ...this.props.styles
              }}
            >
              <div className={styles.IA_iconTile}>
                <IAIcon
                  title={this.props.icon ?? this.props.myLinksStore.defaultLinkIcon}
                  size={32}
                  color={this.props.myLinksStore.hasDarkBackground ? "#ffffff" : this.props.myLinksStore.linkIconColor ?? this.props.myLinksStore.highlightColor}
                />
              </div>

              <div
                className={styles.IA_titleTile}
                style={{
                  color: this.props.myLinksStore.hasDarkBackground ? "#ffffff" : this.props.myLinksStore.linkTextColor ?? "#333333"
                }}
              >
                <div><span>{this.props.title}</span></div>
              </div>
            </div>
          </a>
        );
        break;
      default:
        break;
    }
    return (
      this.props.showSkeleton ?
        <div
          className={styles.IA_linkButtonSkeleton}
          style={{
            height: this.props.myLinksStore.editMode || this.props.myLinksStore.displayType === "Standard" ? 50 : 30
          }}
        >
          <div
            className={styles.IA_linkButtonSkeletonBg}
            style={{
              height: this.props.myLinksStore.editMode || this.props.myLinksStore.displayType === "Standard" ? 50 : 30
            }}
          />
        </div>
        :
        link
    );
  }


}